
































import "./project-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
let _ = require("lodash");

export default Vue.extend({
  name: "due-date-setup",
  components: {
    VueTagsInput,
  },
  props: {
    card: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        dueDate: [
          {
            type: "date",
            required: true,
            message: "Please select due date",
            trigger: "blur",
          },
        ],
        dueTime: [
          {
            type: "string",
            required: true,
            message: "lease select due time",
            trigger: "blur",
          },
        ],
      },
      timeOptions: [
        { value: "00:00", label: "12:00 AM", disabled: false },
        { value: "00:30", label: "12:30 AM", disabled: false },
        { value: "01:00", label: "1:00 AM", disabled: false },
        { value: "01:30", label: "1:30 AM", disabled: false },
        { value: "02:00", label: "2:00 AM", disabled: false },
        { value: "02:30", label: "2:30 AM", disabled: false },
        { value: "03:00", label: "3:00 AM", disabled: false },
        { value: "03:30", label: "3:30 AM", disabled: false },
        { value: "04:00", label: "4:00 AM", disabled: false },
        { value: "04:30", label: "4:30 AM", disabled: false },
        { value: "05:00", label: "5:00 AM", disabled: false },
        { value: "05:30", label: "5:30 AM", disabled: false },
        { value: "06:00", label: "6:00 AM", disabled: false },
        { value: "06:30", label: "6:30 AM", disabled: false },
        { value: "07:00", label: "7:00 AM", disabled: false },
        { value: "07:30", label: "7:30 AM", disabled: false },
        { value: "08:00", label: "8:00 AM", disabled: false },
        { value: "08:30", label: "8:30 AM", disabled: false },
        { value: "09:00", label: "9:00 AM", disabled: false },
        { value: "09:30", label: "9:30 AM", disabled: false },
        { value: "10:00", label: "10:00 AM", disabled: false },
        { value: "10:30", label: "10:30 AM", disabled: false },
        { value: "11:00", label: "11:00 AM", disabled: false },
        { value: "11:30", label: "11:30 AM", disabled: false },
        { value: "12:00", label: "12:00 PM", disabled: false },
        { value: "12:30", label: "12:30 PM", disabled: false },
        { value: "13:00", label: "1:00 PM", disabled: false },
        { value: "13:30", label: "1:30 PM", disabled: false },
        { value: "14:00", label: "2:00 PM", disabled: false },
        { value: "14:30", label: "2:30 PM", disabled: false },
        { value: "15:00", label: "3:00 PM", disabled: false },
        { value: "15:30", label: "3:30 PM", disabled: false },
        { value: "16:00", label: "4:00 PM", disabled: false },
        { value: "16:30", label: "4:30 PM", disabled: false },
        { value: "17:00", label: "5:00 PM", disabled: false },
        { value: "17:30", label: "5:30 PM", disabled: false },
        { value: "18:00", label: "6:00 PM", disabled: false },
        { value: "18:30", label: "6:30 PM", disabled: false },
        { value: "19:00", label: "7:00 PM", disabled: false },
        { value: "19:30", label: "7:30 PM", disabled: false },
        { value: "20:00", label: "8:00 PM", disabled: false },
        { value: "20:30", label: "8:30 PM", disabled: false },
        { value: "21:00", label: "9:00 PM", disabled: false },
        { value: "21:30", label: "9:30 PM", disabled: false },
        { value: "22:00", label: "10:00 PM", disabled: false },
        { value: "22:30", label: "10:30 PM", disabled: false },
        { value: "23:00", label: "11:00 PM", disabled: false },
        { value: "23:30", label: "11:30 PM", disabled: false },
      ],
      currentCard: {
        completed: false,
        dueDate: null,
        dueTime: null,
      },
      isUpdate: false,
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        if (this.card.dueDateSetting) {
          let setting = Object.assign({}, this.card.dueDateSetting);
          this.isUpdate = setting.dueDate !== undefined && setting.dueDate !== null;
          this.currentCard.completed = setting.completed === true;
          this.currentCard.dueDate = setting.dueDate ? new Date(moment(setting.dueDate).format("MM/DD/YYYY")) : null;
          this.currentCard.dueTime = setting.dueDate ? moment(setting.dueDate).format("HH:mm") : null;
        } else {
          this.isUpdate = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters("project", ["canEditCurrentProject"]),
    showModal(): boolean {
      return this.showEditor;
    },
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let form = this.$refs.SetupForm;
      (form as any).validate((valid: boolean) => {
        if (valid) {
          let setting = { completed: this.currentCard.completed, dueDate: new Date(`${moment(this.currentCard.dueDate).format("YYYY-MM-DD")} ${this.currentCard.dueTime}`) };
          this.$emit("save", setting);
          target.disabled = false;
        } else {
          target.disabled = false;
        }
      });
    },
    handleRemove() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let form = this.$refs.SetupForm;
      (form as any).validate((valid: boolean) => {
        if (valid) {
          let setting = { completed: false, dueDate: null };
          this.$emit("save", setting);
          target.disabled = false;
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
